import { useEffect, useState } from 'react';
import { useAppSelector, useAppDispatch } from '@store';
import {
  Popup,
  InputText,
  ToggleInput,
  NotificationTemplateTypes,
} from '@ui/src';
import { onTemplateChange } from './store/slices';
import TemplateColumn from '../../components/notification-settings/template-columns';
import { useEditTemplateMutation } from './store/services';

import cn from './notification-settings.module.css';

const TemplateColumns = () => {
  const dispatch = useAppDispatch();
  const [renamePopupVisible, setRenamePopupVisible] = useState(false);
  const [templateName, setTemplateName] = useState('');
  const [active, setActive] = useState(false);

  const { templates, templateId, selectedTemplate } = useAppSelector(
    (state) => state.notificationSettings.templates,
  );

  const [editTemplate, { isLoading, isSuccess }] = useEditTemplateMutation();

  const onRenameTemplate = async () => {
    const availableEnums = selectedTemplate?.notificationsTypes
      ?.filter((item) => item.includes('_ACTION'))
      .map((item) => item.replace('_ACTION', ''));

    await editTemplate({
      id: selectedTemplate?.id as string,
      body: {
        name: templateName,
        active,
        notificationsTypes: availableEnums as NotificationTemplateTypes[],
      },
    });
  };

  useEffect(() => {
    if (isSuccess) {
      setRenamePopupVisible(false);
      setTemplateName('');
    }
  }, [isSuccess]);

  useEffect(() => {
    if (templates && templates.length && !templateId) {
      dispatch(onTemplateChange(templates[0].id));
    }
  }, [templates, templateId]);

  useEffect(() => {
    if (selectedTemplate && renamePopupVisible) {
      setTemplateName(selectedTemplate.name);
      setActive(selectedTemplate.active);
    }
  }, [selectedTemplate, renamePopupVisible]);

  return (
    <div className={cn.columnWrapper}>
      <TemplateColumn
        templateId={templateId}
        templates={templates}
        emptyTitle="No templates yet"
        setRenamePopupVisible={setRenamePopupVisible}
      />
      <Popup
        title="Rename template"
        onCancelClick={() => {
          setRenamePopupVisible(false);
          setTemplateName('');
        }}
        isVisible={renamePopupVisible}
        onOkClick={() => onRenameTemplate()}
        okButtonText={isLoading ? 'Loading...' : 'Save'}
        cancelButtonText="Cancel"
        okButtonDisabled={isLoading}
      >
        <div className={cn.createTemplateWrapper}>
          <InputText
            name="templateName"
            value={templateName}
            placeholder="Template name..."
            onChange={(e) => setTemplateName(e.target.value)}
            labelClassName={cn.templateName}
          />
          <div className={cn.activeWrapper}>
            <ToggleInput
              name="active"
              title="Active"
              checked={active}
              onChange={(e) => setActive(e.target.checked)}
            />
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default TemplateColumns;
